import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { authAPI } from '../utils/api';
import '../css/login.css';

// Import your image
import loginImage from '../assets/loginImage.jpg';
import logo from '../assets/omega_logo.jpg';

export const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '', role: 'normal_user' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await authAPI.login(formData);
      login(response.data.user, response.data.token);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    }
  };

  return (
    <div className="login-container">
      <div className="login-wrapper">
        {/* Left side - Image/Illustration */}
        <div
          className="login-image-section"
          style={{ backgroundImage: `url(${loginImage})` }}
        >
          <div className="image-overlay">
            <h1>Hey, Welcome Back</h1>
            <p>Sign in to access your account and continue your journey with us.</p>
            <div className="features">
              <div className="feature">
                <span className="feature-icon">✓</span>
                <span>Secure & reliable authentication</span>
              </div>
              <div className="feature">
                <span className="feature-icon">✓</span>
                <span>Access multiple role-based dashboards</span>
              </div>
              <div className="feature">
                <span className="feature-icon">✓</span>
                <span>Real-time updates and notifications</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right side - Login Form */}
        <div className="login-form-section">
          <div className="login-card">
            <div className="login-header">
              <img src={logo} alt="Omega Logo" className="logo" />
              <h2>Welcome Back</h2>
              <p>Please enter your details to sign in</p>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Password</label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    placeholder="Enter your password"
                    required
                  />
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  >
                    <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Role</label>
                <select
                  className="form-select"
                  value={formData.role}
                  onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                >
                  <option value="admin">Admin</option>
                  <option value="sales_manager">Sales Manager</option>
                  <option value="purchase_manager">Purchase Manager</option>
                  <option value="normal_user">Normal User</option>
                </select>
              </div>

              <button type="submit" className="btn-login">Sign In</button>
            </form>

            {/* <p className="signup-link">
              Don't have an account? <a href="/register">Sign Up</a>
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
};